import { useEffect, useRef } from "react";
import Quill from "quill";
import "quill/dist/quill.snow.css";

interface EditorProps {
  name: string;
  value: string;
  onChange: (name: string, value: string) => void;
  height?: string;
}

export default function QuillEditor({
  name,
  value,
  onChange,
  height = "300px",
}: EditorProps) {
  const editorRef = useRef<HTMLDivElement | null>(null);
  const quillRef = useRef<Quill | null>(null);

  useEffect(() => {
    if (!editorRef.current || quillRef.current) return;

    const quill = new Quill(editorRef.current, {
      theme: "snow",
      placeholder: "Write something...",
      modules: {
        toolbar: [
          [{ font: [] }, { size: [] }],
          [{ header: [1, 2, 3, 4, 5, 6, false] }],

          ["bold", "italic", "underline", "strike"],
          [{ color: [] }, { background: [] }],

          [{ script: "sub" }, { script: "super" }],
          [{ list: "ordered" }, { list: "bullet" }],
          [{ indent: "-1" }, { indent: "+1" }],

          [{ direction: "rtl" }, { align: [] }],

          ["link", "image", "video"],
          ["blockquote", "code-block"],

          ["clean"],
        ],
      },
    });

    quill.on("text-change", () => {
      onChange(name, quill.root.innerHTML);
    });

    quillRef.current = quill;
  }, []);

  useEffect(() => {
    if (quillRef.current && value !== quillRef.current.root.innerHTML) {
      quillRef.current.root.innerHTML = value || "";
    }
  }, [value]);

  return <div ref={editorRef} style={{ height }} />;
}